import axios from "axios"; 

const APIConfig = axios.create({ 
    baseURL: "https://magangprodb.herokuapp.com/api/",  
}); 

export default APIConfig;